/*! jck-vsl-video-fix · 20260805b */
(function () {
  if (window.__jckVslGuard) return;
  window.__jckVslGuard = true;

  var BOTTOM_SRC = "4397fcc8070d4d9f91e1fcbff3a10917";

  function isBottomVideo(el) {
    if (!el || el.tagName !== "VIDEO") return false;
    if (el.closest && el.closest(".jck-bottom-vsl")) return true;
    if (el.classList && el.classList.contains("jck-bottom-video")) return true;
    var src = (el.currentSrc || el.src || "") + "";
    var sources = el.querySelectorAll("source");
    for (var i = 0; i < sources.length; i++) {
      src += sources[i].getAttribute("src") || "";
    }
    return src.indexOf(BOTTOM_SRC) !== -1;
  }

  function cleanBottomSource(el) {
    if (!isBottomVideo(el)) return;
    el.querySelectorAll("source").forEach(function (s) {
      var u = s.getAttribute("src") || "";
      if (u.indexOf("#") !== -1) s.setAttribute("src", u.split("#")[0]);
    });
    var direct = el.getAttribute("src") || "";
    if (direct.indexOf("#") !== -1) el.setAttribute("src", direct.split("#")[0]);
    el.dataset.jckNoSeek = "1";
    el.dataset.jckBottomExempt = "1";
  }

  // IMPORTANT: return a real Array so theme code using [0], spread, or for...of still works.
  // The old fake {length, forEach}-only object broke video handling site-wide.
  function patchQuerySelectorAll(proto) {
    var orig = proto.querySelectorAll;
    proto.querySelectorAll = function (sel) {
      var list = orig.call(this, sel);
      if (!sel || typeof sel !== "string" || sel.indexOf("video") === -1) {
        return list;
      }
      var out = [];
      for (var i = 0; i < list.length; i++) {
        var el = list[i];
        if (el && el.tagName === "VIDEO") cleanBottomSource(el);
        if (!isBottomVideo(el)) out.push(el);
      }
      return out;
    };
  }
  patchQuerySelectorAll(Document.prototype);
  patchQuerySelectorAll(Element.prototype);

  var _ael = HTMLVideoElement.prototype.addEventListener;
  HTMLVideoElement.prototype.addEventListener = function (type, listener, options) {
    if (
      isBottomVideo(this) &&
      (type === "seeking" ||
        type === "seeked" ||
        type === "timeupdate" ||
        type === "ratechange" ||
        type === "webkitpresentationmodechanged")
    ) {
      return;
    }
    return _ael.call(this, type, listener, options);
  };

  function scanVideos() {
    var list = Document.prototype.querySelectorAll.call(document, "video");
    for (var i = 0; i < list.length; i++) cleanBottomSource(list[i]);
  }
  if (document.documentElement) {
    scanVideos();
    new MutationObserver(scanVideos).observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  } else {
    document.addEventListener("DOMContentLoaded", scanVideos);
  }
})();

(function () {
  if (window.__jckVslVideoFix) return;
  window.__jckVslVideoFix = true;
  window.__jckVslVideoFixVer = "20260805b";

  var BOTTOM_SRC = "4397fcc8070d4d9f91e1fcbff3a10917";
  var BOTTOM_MP4 =
    "https://cdn.shopify.com/videos/c/o/v/4397fcc8070d4d9f91e1fcbff3a10917.mp4";

  function isBottomVideo(el) {
    if (!el || el.tagName !== "VIDEO") return false;
    if (el.closest && el.closest(".jck-bottom-vsl")) return true;
    if (el.classList && el.classList.contains("jck-bottom-video")) return true;
    var src = (el.currentSrc || el.src || "") + "";
    var sources = el.querySelectorAll("source");
    for (var i = 0; i < sources.length; i++) {
      src += sources[i].getAttribute("src") || "";
    }
    return src.indexOf(BOTTOM_SRC) !== -1;
  }

  function isVslPage() {
    var p = (location.pathname || "").toLowerCase();
    if (p.indexOf("jeff-hidden") !== -1) return true;
    if (p.indexOf("hidden-switch-vsl") !== -1) return true;
    if (p.indexOf("unfairadvantage") !== -1) return true;
    return !!(
      document.getElementById("jcked-vsl") ||
      document.getElementById("jcked-lp") ||
      document.getElementById("jcked-vsl2")
    );
  }

  function hideFooter() {
    if (!isVslPage()) return;
    if (!document.getElementById("jck-vsl-hide-footer")) {
      var style = document.createElement("style");
      style.id = "jck-vsl-hide-footer";
      style.textContent =
        ".shopify-section-group-footer-group,footer.footer,[id^='shopify-section'][id*='footer']{display:none!important;}" +
        "#jcked-vsl .vslsound,#jcked-lp .vslsound{opacity:1!important;pointer-events:auto!important;}" +
        "#jcked-vsl .vslsound.is-hidden,#jcked-lp .vslsound.is-hidden{opacity:0!important;pointer-events:none!important;}" +
        "#jcked-vsl .jck-top-play,#jcked-lp .jck-top-play{position:absolute;inset:0;z-index:4;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,.35);border:0;cursor:pointer;border-radius:16px;-webkit-tap-highlight-color:transparent;}" +
        "#jcked-vsl .jck-top-play[hidden],#jcked-lp .jck-top-play[hidden]{display:none!important;}" +
        "#jcked-vsl .jck-top-play span,#jcked-lp .jck-top-play span{width:74px;height:74px;border-radius:999px;background:#CE1126;display:flex;align-items:center;justify-content:center;box-shadow:0 10px 28px rgba(206,17,38,.45);}";
      document.head.appendChild(style);
    }
  }

  function findBottomVideo() {
    var byId = document.getElementById("jck-bottom-vsl-video");
    if (byId) return byId;
    var wrap = document.querySelector(".jck-bottom-vsl");
    if (wrap) {
      var v = wrap.querySelector("video");
      if (v) return v;
    }
    var videos = Document.prototype.querySelectorAll.call(document, "video");
    for (var i = 0; i < videos.length; i++) {
      if (isBottomVideo(videos[i])) return videos[i];
    }
    return null;
  }

  function resetBottomVideo(vid) {
    if (!vid || vid.dataset.jckBottomReset === "1") return vid;
    var wrap = vid.closest(".jck-bottom-vsl") || vid.parentElement;
    if (!wrap) return vid;

    var fresh = document.createElement("video");
    fresh.id = "jck-bottom-vsl-video";
    fresh.className = "vsl jck-bottom-video";
    fresh.setAttribute("playsinline", "");
    fresh.setAttribute("webkit-playsinline", "");
    fresh.setAttribute("preload", "metadata");
    fresh.style.cssText =
      vid.style.cssText ||
      "width:100%;height:auto;display:block;border-radius:16px;background:#1a1a1a;";
    fresh.innerHTML = '<source src="' + BOTTOM_MP4 + '" type="video/mp4">';
    fresh.dataset.jckBottomReset = "1";
    fresh.dataset.jckNoSeek = "1";
    fresh.dataset.jckBottomExempt = "1";
    fresh.controls = false;
    fresh.playsInline = true;

    var btn = wrap.querySelector(".jck-bottom-play");
    vid.parentNode.replaceChild(fresh, vid);
    if (btn) wrap.appendChild(btn);
    return fresh;
  }

  function ensureBottomPlay() {
    var vid = findBottomVideo();
    if (!vid) return;
    vid = resetBottomVideo(vid);
    if (vid.dataset.jckBottomWired === "1") return;
    vid.dataset.jckBottomWired = "1";

    var wrap = vid.closest(".jck-bottom-vsl") || vid.parentElement;
    if (!wrap) return;
    wrap.classList.add("jck-bottom-vsl");
    wrap.style.position = wrap.style.position || "relative";
    wrap.style.cursor = "pointer";

    var btn = wrap.querySelector(".jck-bottom-play");
    if (!btn) {
      btn = document.createElement("div");
      btn.className = "jck-bottom-play";
      btn.setAttribute("role", "button");
      btn.setAttribute("tabindex", "0");
      btn.setAttribute("aria-label", "Play video");
      btn.style.cssText =
        "position:absolute;inset:0;z-index:5;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,.4);border-radius:16px;cursor:pointer;-webkit-tap-highlight-color:transparent;";
      btn.innerHTML =
        '<span style="width:74px;height:74px;border-radius:999px;background:#CE1126;display:flex;align-items:center;justify-content:center;box-shadow:0 10px 28px rgba(206,17,38,.45);pointer-events:none;"><svg width="28" height="28" viewBox="0 0 24 24" fill="#fff" aria-hidden="true"><path d="M8 5v14l11-7z"></path></svg></span>';
      wrap.appendChild(btn);
    }

    var activating = false;
    function hideBtn() {
      btn.style.display = "none";
    }
    function showBtn() {
      btn.style.display = "flex";
    }
    function startPlay() {
      vid.setAttribute("playsinline", "");
      vid.setAttribute("webkit-playsinline", "");
      vid.playsInline = true;
      vid.muted = true;
      vid.volume = 1;
      var p = vid.play();
      if (p && p.then) {
        p.then(function () {
          hideBtn();
          try {
            vid.muted = false;
            vid.volume = 1;
          } catch (e) {}
        }).catch(function () {
          showBtn();
        });
      } else {
        hideBtn();
      }
    }
    function onActivate(e) {
      if (activating) return;
      activating = true;
      setTimeout(function () {
        activating = false;
      }, 450);
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      if (vid.paused || vid.ended) {
        if (vid.ended) vid.currentTime = 0;
        startPlay();
      } else {
        vid.pause();
        showBtn();
      }
    }

    btn.addEventListener("pointerup", onActivate);
    btn.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") onActivate(e);
    });
    vid.addEventListener("play", hideBtn);
    vid.addEventListener("pause", function () {
      if (!vid.ended) showBtn();
    });
    vid.addEventListener("ended", showBtn);
  }

  function enhanceTopAudio() {
    var roots = [
      document.getElementById("jcked-vsl"),
      document.getElementById("jcked-lp"),
    ];
    roots.forEach(function (root) {
      if (!root) return;
      var vid = root.querySelector("video.vsl");
      if (!vid || isBottomVideo(vid)) return;

      var wrap = vid.closest(".vslwrap") || vid.parentElement;
      var soundBtn = root.querySelector(".vslsound");

      function showSoundBtn() {
        if (!soundBtn) return;
        soundBtn.classList.remove("is-hidden");
        soundBtn.style.opacity = "1";
        soundBtn.style.pointerEvents = "auto";
      }
      function hideSoundBtn() {
        if (!soundBtn) return;
        soundBtn.classList.add("is-hidden");
      }

      function ensurePlayBtn() {
        if (!wrap) return null;
        var btn = wrap.querySelector(".jck-top-play");
        if (btn) return btn;
        btn = document.createElement("button");
        btn.type = "button";
        btn.className = "jck-top-play";
        btn.setAttribute("aria-label", "Play video");
        btn.innerHTML =
          '<span><svg width="28" height="28" viewBox="0 0 24 24" fill="#fff" aria-hidden="true"><path d="M8 5v14l11-7z"></path></svg></span>';
        wrap.appendChild(btn);
        return btn;
      }

      var playBtn = ensurePlayBtn();

      function showPlayBtn() {
        if (playBtn) playBtn.hidden = false;
      }
      function hidePlayBtn() {
        if (playBtn) playBtn.hidden = true;
      }

      function startMuted() {
        try {
          vid.defaultMuted = true;
          vid.muted = true;
          vid.volume = 1;
          vid.setAttribute("muted", "");
          vid.setAttribute("playsinline", "");
          vid.setAttribute("webkit-playsinline", "");
          vid.playsInline = true;
          vid.loop = true;
          var p = vid.play();
          if (p && p.then) {
            return p.then(function () {
              hidePlayBtn();
              showSoundBtn();
            }).catch(function () {
              showPlayBtn();
              showSoundBtn();
            });
          }
          hidePlayBtn();
          showSoundBtn();
        } catch (e) {
          showPlayBtn();
          showSoundBtn();
        }
      }

      function enableSound() {
        vid.muted = false;
        vid.volume = 1;
        var p = vid.play();
        if (p && p.then) {
          p.then(function () {
            hideSoundBtn();
            hidePlayBtn();
          }).catch(function () {
            showSoundBtn();
            startMuted();
          });
        } else {
          hideSoundBtn();
          hidePlayBtn();
        }
      }

      if (root.dataset.jckTopAudioWired === "1") {
        // Already wired — just keep UI in sync if autoplay stalled.
        if (vid.paused) showPlayBtn();
        else hidePlayBtn();
        if (vid.muted || vid.volume === 0) showSoundBtn();
        return;
      }
      root.dataset.jckTopAudioWired = "1";

      vid.setAttribute("autoplay", "");
      vid.setAttribute("muted", "");
      vid.setAttribute("loop", "");
      vid.setAttribute("playsinline", "");
      vid.setAttribute("webkit-playsinline", "");
      vid.defaultMuted = true;
      vid.muted = true;
      vid.loop = true;
      vid.playsInline = true;

      startMuted();
      vid.addEventListener("loadeddata", function () {
        if (vid.paused) startMuted();
      });
      vid.addEventListener("canplay", function () {
        if (vid.paused) startMuted();
      });
      vid.addEventListener("playing", function () {
        hidePlayBtn();
        if (vid.muted || vid.volume === 0) showSoundBtn();
        else hideSoundBtn();
      });
      vid.addEventListener("pause", function () {
        if (!vid.ended) showPlayBtn();
        showSoundBtn();
      });
      vid.addEventListener("stalled", showPlayBtn);
      vid.addEventListener("waiting", function () {
        /* keep current UI; do not hide play while buffering after a tap */
      });
      vid.addEventListener("error", function () {
        showPlayBtn();
        showSoundBtn();
      });
      vid.addEventListener("volumechange", function () {
        if (vid.muted || vid.volume === 0) showSoundBtn();
        else hideSoundBtn();
      });

      if (playBtn) {
        playBtn.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          startMuted();
        });
      }
      if (soundBtn) {
        soundBtn.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          enableSound();
        });
      }
      // Tap the video frame itself to start if autoplay was blocked.
      vid.addEventListener("click", function () {
        if (vid.paused) startMuted();
      });

      showSoundBtn();
      if (vid.paused) showPlayBtn();
    });
  }

  function run() {
    hideFooter();
    try {
      ensureBottomPlay();
    } catch (e) {}
    try {
      enhanceTopAudio();
    } catch (e) {}
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }
  var n = 0;
  var iv = setInterval(function () {
    run();
    if (++n > 40) clearInterval(iv);
  }, 300);
})();
